import {makeAutoObservable} from 'mobx';
import {Title} from '../../entity/model/title';
import {RequestBody} from '../../entity/core/request-body';
import {UniqueIdentifier} from '@dnd-kit/core';
import SectionAgent from '../agent/section-agent';
import {Items} from '../../entity/resource/items';
import {TitleTemplate} from '../../entity/model/title-template';

export default class SectionStore {
  sectionAgent: SectionAgent;
  selectedIds: UniqueIdentifier[] = [];
  movableItems: Items = {};
  isSectionMoving: boolean = false;
  movingSectionId: UniqueIdentifier | string = '';
  expandSingleContainer: boolean = false;
  expandedSectionIds: UniqueIdentifier[] = [];
  expandAllContainers: boolean = false;
  viewDocument: boolean = false;

  constructor(sectionAgent: SectionAgent) {
    makeAutoObservable(this);
    this.sectionAgent = sectionAgent;
  }

  moveSection = async (organizationId: string, requestBody: RequestBody, titleId?: string, templateId?: string): Promise<Title | TitleTemplate | string> => {
    try {
      return await this.sectionAgent.moveSection(organizationId, requestBody, titleId, templateId);
    } catch (error: any) {
      console.error('Error occurred while move the section', error);
      return 'Error occurred while move the section';
    }
  }

  deleteSection = async (organizationId: string, sectionId: UniqueIdentifier, titleId?: string, templateId?: string): Promise<string | undefined> => {
    try {
      await this.sectionAgent.deleteSection(organizationId, sectionId, titleId, templateId);
    } catch (error: any) {
      console.error('Error occurred while delete the section', error);
      return 'Error occurred while delete the section';
    }
  }

  addNewSection = async (organizationId: string, templateId: string, requestBody: RequestBody): Promise<TitleTemplate | string> => {
    try {
      return await this.sectionAgent.addNewSection(organizationId, templateId, requestBody);
    } catch (error: any) {
      console.error('Error occurred while add new section', error);
      return 'Error occurred while add new section !!';
    }
  }
}
